module.exports = __webpack_public_path__ + "static/media/apple-pay.8283e169.svg";